/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { convertToMarkdownString } from "abreact/input/markdown/utils/MarkdownExport";
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import { AB_MARKDOWN_TRANSFORMERS } from "abreact/input/markdown/utils/MarkdownTransformers";
import { useEffect } from 'react';
import * as React from 'react';
/** Calls `onChange` with new markdown whenever the editor changes */
export function OnChangeMarkdownPlugin(props) {
  const [editor] = useLexicalComposerContext();
  const [currentMarkdown, setCurrentMarkdown] = React.useState("");
  useEffect(() => {
    const onChange = props.onChange;
    return mergeRegister(editor.registerUpdateListener(({
      editorState
    }) => {
      editorState.read(() => {
        const markdown = convertToMarkdownString(AB_MARKDOWN_TRANSFORMERS);
        if (currentMarkdown !== markdown) {
          // make sure markdown is new
          onChange(markdown);
          setCurrentMarkdown(markdown);
        }
      });
    }));
  }, [currentMarkdown, editor, props.onChange]);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
}
//# sourceMappingURL=OnChangeMarkdownPlugin.js.map
